export default {
  number: '0942456000',
  display: '0942456000',
  currency: 'EUR',
  tracking: {},
};
